<template>
  <div class="container z-depth-1 mt-5 p-lg-5">
    <!-- Section -->
    <section class="provider-body">
      <h2 class="font-weight-bold text-center section-title pb-2">
        Comment ça marche pour les artisans&nbsp;?
      </h2>
      <hr class="w-header my-4" />
      <p class="lead text-center section-lead pt-2 mb-5">
        En quelques étapes, vous connectez vos <strong>chantiers</strong> au
        réseau Livratos&nbsp;: vous créez votre compte, nous validons votre
        profil, vous demandez des <strong>livraisons</strong> et vos courses
        sont regroupées en fin de période.
      </p>

      <div class="row d-flex justify-content-center px-3">
        <!-- Étape 1 : Inscription -->
        <div class="col-md-6 col-xl-4 slide-left">
          <div class="step-label step-1">
            <h3 class="font-weight-normal service-title">
              1. Inscription en ligne
            </h3>
            <p class="small service-tag">
              Création de votre espace entreprise / <strong>artisan</strong>
            </p>
          </div>
        </div>
        <div class="col-md-6 slide-right">
          <div class="step-panel step-1">
            <p class="service-text mb-5 pb-2">
              Vous créez votre compte <strong>Artisan</strong> en quelques
              minutes&nbsp;: Email et mot de passe pour accéder à votre compte
              livratos, vos coordonnées, et documents à téléversés. Une fois la
              demande envoyée, vos informations arrivent directement à notre
              équipe pour validation.
            </p>
          </div>
        </div>

        <!-- Étape 2 : Activation du compte -->
        <div class="col-md-6 col-xl-4 slide-left">
          <div class="step-label step-2">
            <h3 class="font-weight-normal service-title">
              2. Validation & activation
            </h3>
            <p class="small service-tag">Contrôle & paramétrage</p>
          </div>
        </div>

        <div class="col-md-6 slide-right">
          <div class="step-panel step-2">
            <p class="service-text mb-5 pb-2">
              Une fois votre compte créé et votre profil complété (coordonnées,
              raison sociale, documents obligatoires…), notre équipe vérifie
              votre dossier puis vous contacte avant toute activation. C’est à
              ce moment-là que nous voyons ensemble la meilleure façon de lancer
              le service&nbsp;: activation immédiate, organisation d’une démo de
              la plateforme, ou accompagnement plus poussé pour former vos
              équipes et vous aider à prendre en main l’outil. Une fois ces
              derniers points validés avec vous, votre compte
              <strong>Artisan</strong> est activé.
            </p>
          </div>
        </div>

        <!-- Étape 3 : Demande de livraisons -->
        <div class="col-md-6 col-xl-4 slide-left">
          <div class="step-label step-3">
            <h3 class="font-weight-normal service-title">
              3. Demandez vos livraisons
            </h3>
            <p class="small service-tag">
              Express & programmées pour vos <strong>chantiers</strong>
            </p>
          </div>
        </div>

        <div class="col-md-6 slide-right">
          <div class="step-panel step-3">
            <p class="service-text mb-5 pb-2">
              Depuis votre interface Livratos (bureau ou
              <strong>chantier</strong>), vous créez des
              <strong>livraisons express ou programmées</strong>&nbsp;:
              <strong>fournisseur</strong>, point de retrait, adresse
              <strong>chantier</strong>, créneau souhaité, type de véhicule et
              contraintes d’accès. La plateforme affecte un
              <strong>livreur</strong> adapté et vous suivez chaque course
              jusqu’à la remise sur site.
            </p>
          </div>
        </div>

        <!-- Étape 4 : Facturation -->
        <div class="col-md-6 col-xl-4 slide-left">
          <div class="step-label step-4">
            <h3 class="font-weight-normal service-title">
              4. Facturation regroupée
            </h3>
            <p class="small service-tag">
              Suivi par <strong>chantier</strong> & compta simplifiée
            </p>
          </div>
        </div>

        <div class="col-md-6 slide-right">
          <div class="step-panel step-4">
            <p class="service-text mb-5 pb-2">
              Toutes les <strong>livraisons</strong> passées via Livratos sont
              <strong>regroupées par période</strong> (8&nbsp;jours ou fin de
              mois). Vous recevez une facture unique avec le détail des courses
              <strong>par chantier</strong>, ce qui facilite le suivi de vos
              coûts logistiques et l’analyse de la rentabilité
              <strong>chantier</strong> par <strong>chantier</strong>.
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- Section -->
  </div>
</template>

<script>
export default {
  name: "ProviderBodyArtisan",
};
</script>

<style lang="scss" scoped>
.provider-body {
  .section-title {
    color: $color-text;
  }

  .section-lead {
    color: $color-text-grey;
    font-size: 1.05rem;
  }

  /* Bloc titre + tag */
  .step-label {
    padding: 1.4rem 1.6rem;
    border-radius: 10px;
    margin-bottom: 1rem;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  }

  /* panneaux texte */
  .step-panel {
    padding: 1.1rem 1.4rem;
    border-radius: 10px;
    margin-bottom: 1.5rem;
    background-color: $background;
    border-left: 3px solid transparent;
  }

  .service-title {
    margin: 0;
    font-size: 1.2rem;
  }

  .service-tag {
    margin: 0.4rem 0 0;
    font-size: 0.85rem;
    font-weight: 600;
  }

  .service-text {
    color: $color-text-grey;
    font-size: 0.98rem;
    line-height: 1.6;
    margin: 0;
  }

  /* Alternance vert / noir */

  /* Étape 1 & 3 : fond vert */
  .step-1.step-label,
  .step-3.step-label {
    background-color: $color-primary;
    .service-title {
      color: #000;
    }
    .service-tag {
      color: #000;
      opacity: 0.85;
    }
  }

  .step-1.step-panel,
  .step-3.step-panel {
    border-left-color: $color-primary;
  }

  /* Étape 2 & 4 : fond noir */
  .step-2.step-label,
  .step-4.step-label {
    background-color: #000;
    .service-title {
      color: $color-primary;
    }
    .service-tag {
      color: #ffffff;
      opacity: 0.85;
    }
  }

  .step-2.step-panel,
  .step-4.step-panel {
    border-left-color: #000;
  }

  @media (max-width: 767.98px) {
    .step-label {
      text-align: left;
    }
    .section-lead {
      font-size: 1rem;
    }
  }
}
</style>
